import React from 'react';
import moment from 'moment';
import { Collapse, Tag, Divider } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import './style.css';

const VersionHistoryTab = ({ instrumentData }) => {
  console.log('VersionHistoryTab - Renderizando com dados:', instrumentData);

  // Se não tem dados, mostra carregando
  if (!instrumentData) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <p>Carregando dados do instrumento...</p>
      </div>
    );
  }

  // Pega o array de versões
  const versions = instrumentData.versionHistory || [];
  console.log('Versões encontradas:', versions.length);

  // Se não tem versões, mostra mensagem
  if (versions.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <p>Nenhum histórico de versão disponível.</p>
      </div>
    );
  }

  // Função para formatar data
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return moment(dateString).format('DD/MM/YYYY');
  };

  // Função para criar os itens do Collapse
  const getCollapseItems = () => {
    return versions.map((version) => ({
      key: version._id,
      label: (
        <div className="version-collapse-header">
          <div className="version-main-info">
            <Tag color="blue">Versão {version.version}</Tag>
            <span className="version-name">{version.name}</span>
            <span className="version-date">{formatDate(version.versionCreatedAt)}</span>
          </div>
        </div>
      ),
      children: (
        <div className="version-details">
          <div className="details-grid">
            <div className="detail-item">
              <strong>Nome:</strong> {version.name}
            </div>
            <div className="detail-item">
              <strong>Fabricante:</strong> {version.manufacture?.name || '-'}
            </div>
            <div className="detail-item">
              <strong>Categoria:</strong> {version.category?.name || '-'}
            </div>
            <div className="detail-item">
              <strong>Vencimento Certificado:</strong> {formatDate(version.certificate_expiration_date)}
            </div>
            <div className="detail-item">
              <strong>Data da Alteração:</strong> {formatDate(version.versionCreatedAt)}
            </div>
          </div>

          {version.properties && version.properties.length > 0 && (
            <>
              <Divider orientation="left">Propriedades</Divider>
              <div className="properties-section">
                <table className="properties-table">
                  <thead>
                    <tr>
                      <th>Propriedade</th>
                      <th>Valor</th>
                      <th>Tipo</th>
                      <th>Obrigatório</th>
                    </tr>
                  </thead>
                  <tbody>
                    {version.properties.map((prop, propIndex) => (
                      <tr key={propIndex}>
                        <td>{prop.name}</td>
                        <td>{prop.value || '-'}</td>
                        <td>
                          <Tag>{prop.type}</Tag>
                        </td>
                        <td>
                          <Tag color={prop.required ? 'red' : 'default'}>
                            {prop.required ? 'Sim' : 'Não'}
                          </Tag>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      ),
    }));
  };

  return (
    <div className="version-history-tab">
      <div className="version-history-header">
        <div>
          <h3>Histórico de Versões</h3>
          <p className="version-info">
            Versão Atual: <strong>{instrumentData.version || 1}</strong>
          </p>
        </div>
      </div>
      
      <Collapse
        items={getCollapseItems()}
        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
        className="version-collapse"
      />
    </div>
  );
};

export default VersionHistoryTab;